
import { Helmet } from "react-helmet";

const ArabicTermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8" dir="rtl">
      <Helmet>
        <title>شروط الخدمة - Lainasampo.fi</title>
        <meta name="description" content="شروط الخدمة لخدمة مقارنة القروض Lainasampo.fi" />
      </Helmet>
      
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">شروط الخدمة</h1>

        <div className="prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-4">
            هذه ترجمة لشروط الخدمة الخاصة بنا باللغة الفنلندية. النسخة الفنلندية هي النسخة الملزمة قانونًا.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. وصف الخدمة</h2>
          <p className="mb-4">
            Lainasampo.fi هي خدمة لمقارنة القروض وتقديم الطلبات، حيث تقوم بإحالة طلبات القروض إلى شركائها. 
            Lainasampo.fi لا تقدم القروض بنفسها، ولكنها تعمل كوسيط بين العملاء والمؤسسات المالية.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. استخدام الخدمة</h2>
          <p className="mb-4">عند استخدام خدمتنا، يجب عليك:</p>
          <ul className="list-disc pr-6 mb-4 space-y-2">
            <li>تقديم معلومات صحيحة وحديثة في طلب القرض الخاص بك</li>
            <li>أن تكون قد بلغت 18 عامًا على الأقل وتتمتع بالأهلية القانونية</li>
            <li>استخدام الخدمة فقط للأغراض القانونية</li>
            <li>الامتثال للقانون الفنلندي وشروط الخدمة هذه</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. طلبات القروض</h2>
          <p className="mb-4">من خلال تقديم طلب قرض عبر Lainasampo.fi:</p>
          <ul className="list-disc pr-6 mb-4 space-y-2">
            <li>فإنك تفوضنا بإحالة طلبك إلى شركائنا</li>
            <li>أنت تقبل أنه يمكن لشركائنا التحقق من معلومات الائتمان الخاصة بك</li>
            <li>أنت تفهم أن القرار النهائي للقرض يتخذه المؤسسة المالية، وليس Lainasampo.fi</li>
            <li>أنت تقبل أنه يمكننا الاتصال بك بخصوص طلب القرض الخاص بك</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. عروض القروض</h2>
          <p className="mb-4">
            يتم تقديم عروض القروض من قبل شركائنا. لا يمكننا ضمان أنك ستتلقى عروض قروض أو أن العروض 
            ستلبي توقعاتك. تعتمد شروط العروض التي تتلقاها على عدة عوامل، مثل معلومات الائتمان الخاصة بك 
            ودخلك وسياسات الإقراض للمؤسسات المالية.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. مجانية الخدمة</h2>
          <p className="mb-4">
            خدمات Lainasampo.fi مجانية للعملاء. نحن نمول عملياتنا من خلال العمولات 
            التي يدفعها شركاؤنا.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. حدود المسؤولية</h2>
          <p className="mb-4">Lainasampo.fi ليست مسؤولة عن:</p>
          <ul className="list-disc pr-6 mb-4 space-y-2">
            <li>قرارات القروض التي يتخذها الشركاء أو شروط عروضهم</li>
            <li>سداد القرض أو العلاقات بين المقترض والمقرض</li>
            <li>الأضرار غير المباشرة أو التبعية التي قد تنتج عن استخدام الخدمة</li>
            <li>انقطاع الخدمة المؤقت أو المشاكل التقنية</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. حقوق الملكية الفكرية</h2>
          <p className="mb-4">
            جميع محتويات Lainasampo.fi، بما في ذلك النصوص والصور والشعارات وبرامج الكمبيوتر وغيرها من المواد، 
            محمية بحقوق الملكية الفكرية وتنتمي إلى Lainasampo Oy أو المرخصين لها. يحظر نسخ أو توزيع أو 
            استخدام المحتوى بطريقة أخرى دون إذن.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. التواصل</h2>
          <p className="mb-4">
            باستخدامك لخدمتنا، فإنك تقبل أنه يمكننا إرسال معلومات إليك حول خدمتنا وطلب القرض الخاص بك 
            وعروض القروض عبر البريد الإلكتروني أو وسائل إلكترونية أخرى. يمكنك في أي وقت إلغاء موافقتك على 
            اتصالات التسويق عن طريق الاتصال بخدمة العملاء لدينا.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">9. تغييرات الشروط</h2>
          <p className="mb-4">
            نحتفظ بالحق في تعديل شروط الخدمة هذه. سننشر الشروط المعدلة على موقعنا 
            وستدخل حيز التنفيذ على الفور. استمرار استخدام الموقع بعد التغييرات في الشروط سيعتبر 
            قبولًا للشروط الجديدة.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">10. القانون المطبق وحل النزاعات</h2>
          <p className="mb-4">
            تخضع شروط الخدمة هذه للقانون الفنلندي. سيتم حل أي نزاعات في المقام الأول من خلال 
            التفاوض. إذا تعذر التوصل إلى اتفاق، فسيتم حل النزاعات في محكمة هلسنكي المحلية.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">11. معلومات الاتصال</h2>
          <p className="mb-4">إذا كانت لديك أي أسئلة حول شروط الخدمة، يرجى الاتصال بـ:</p>
          <p>
            Lainasampo Oy<br />
            البريد الإلكتروني: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>

      <p className="text-sm text-gray-500 text-center mt-8 mb-8">تم تحديث هذه الشروط آخر مرة في: 1 يونيو 2023</p>
    </div>
  );
};

export default ArabicTermsPage;
